// extracted by mini-css-extract-plugin
module.exports = {"Footer":"Footer_Footer__2i4Oo"};